var lib_core = require("lib-core");
var ContentServerMetaData = require("../contentServerMetaData.js");

var SymbolMetaData = function () {
    ContentServerMetaData.call(this);
};
lib_core.inherit(SymbolMetaData, ContentServerMetaData);
lib_core.JsonParser.registerClass(SymbolMetaData, "SymbolMetaData");

module.exports = SymbolMetaData;

SymbolMetaData.prototype.assetType = function () {
	return "symbol";
};

SymbolMetaData.prototype.assetPath = function () {
	return "symbols/";
};